import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./addElementsView.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faFilm,
  faHeading,
  faHorizontalRule,
  faImage,
  faInputText,
  faParagraph,
  faRectangle,
} from "@fortawesome/pro-regular-svg-icons";
import { WebsiteBuilderToolbarMenuSections } from "../../WebsiteBuilderToolbarMenuSections";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ElementDraggable } from "../../drag/elementDraggable/ElementDraggable";
import { elementTitles, TWebsiteBuilderElement } from "../../../../nodes/element/websiteBuilderElement";
import { generateDefaultButton } from "../../../../nodes/element/websiteBuilderButton";
import { generateDefaultParagraph } from "../../../../nodes/element/websiteBuilderParagraph";
import { generateDefaultInput } from "../../../../nodes/element/websiteBuilderInput";
import { generateDefaultDivider } from "../../../../nodes/element/websiteBuilderDivider";
import { generateDefaultSelect } from "../../../../nodes/element/websiteBuilderSelect";
import { generateDefaultHeading } from "../../../../nodes/element/websiteBuilderHeading";

interface IAddElementsViewElement {
  icon: IconProp;
  title: string;
  item: TWebsiteBuilderElement;
}

export function AddElementsView() {
  const { t } = useTranslation();
  const generalElements: IAddElementsViewElement[] = useMemo(
    () => [
      {
        icon: faRectangle,
        title: elementTitles.button,
        item: generateDefaultButton(),
      },
      {
        icon: faHeading,
        title: elementTitles.heading,
        item: generateDefaultHeading(),
      },
      {
        icon: faParagraph,
        title: elementTitles.paragraph,
        item: generateDefaultParagraph(),
      },
      {
        icon: faInputText,
        title: elementTitles.input,
        item: generateDefaultInput(),
      },
      {
        icon: faChevronDown,
        title: elementTitles.select,
        item: generateDefaultSelect(),
      },
      {
        icon: faHorizontalRule,
        title: elementTitles.divider,
        item: generateDefaultDivider(),
      },
    ],
    [],
  );

  function renderGeneral() {
    return (
      <div className="website-builder-add-elements-view-elements">
        {generalElements.map((element, index) => {
          return (
            <ElementDraggable key={index} item={element.item}>
              <div className="add-elements-view-element">
                <FontAwesomeIcon className="add-elements-view-element-icon" icon={element.icon} />
                <div className="add-elements-view-element-title">{element.title}</div>
              </div>
            </ElementDraggable>
          );
        })}
      </div>
    );
  }

  function renderMedia() {
    return (
      <div className="website-builder-add-elements-view-elements">
        <div className="add-elements-view-element">
          <FontAwesomeIcon className="add-elements-view-element-icon" icon={faImage} />
          <div className="add-elements-view-element-title">{t("Image")}</div>
        </div>
      </div>
    );
  }

  return (
    <WebsiteBuilderToolbarMenuSections
      sections={[
        {
          title: t("General"),
          content: renderGeneral(),
        },
        {
          title: t("Media"),
          content: renderMedia(),
        },
      ]}
    />
  );
}
